type EmployeeData = {
  netSalary?: number | null;
  grossSalary?: number | null;
  subsidiaryTaxId?: string | null;
  salary?: string;
  salaryType?: 'net' | 'gross';
  paymentFrequency?: string;
  collectives?: Array<{ id: string; name: string }>;
  [key: string]: any;
};

type ProcessedEmployeeData = Record<
  string,
  {
    value: any;
    error: string;
    suggestion: string;
  }
>;

export const mapEmployeeDataToObject = (data: EmployeeData): ProcessedEmployeeData => {
  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => [
      key,
      {
        value,
        error: '',
        suggestion: ''
      }
    ])
  );
};

export const removeUnusedEmployeeKeys = ({
  netSalary,
  grossSalary,
  subsidiaryTaxId,
  collectives,
  ...rest
}: EmployeeData): EmployeeData => rest;

export const processEmployee = (data: EmployeeData | undefined, isoCode: string): ProcessedEmployeeData | undefined => {
  if (!data) return;

  const employeeData = { ...data };

  function formatSalary(salary: number): string {
    return salary.toString().replace('.', ',');
  }

  if (typeof employeeData.netSalary === 'number') {
    employeeData.salary = formatSalary(employeeData.netSalary);
    employeeData.salaryType = 'net';
  } else if (employeeData.netSalary === null && typeof employeeData.grossSalary === 'number') {
    employeeData.salary = formatSalary(employeeData.grossSalary);
    employeeData.salaryType = 'gross';
  } else {
    employeeData.salary = '';
    employeeData.salaryType = 'net';
  }

  if (!employeeData.paymentFrequency) employeeData.paymentFrequency = 'monthly';

  employeeData.collectiveIds = (employeeData.collectives ?? []).map(collective => collective.id);

  const employeeDataWithoutUnusedKeys = removeUnusedEmployeeKeys(employeeData);

  return mapEmployeeDataToObject(employeeDataWithoutUnusedKeys);
};
